import React from "react";
import { get } from "lodash";
import { COMPONENT_MODES, CTA_SIZE, CTA_TYPE } from "../../../data/constants";
import { isAddNewMode, isViewMode } from "../../../helpers/catalog-helper";
import CustomTextField from "../../../components/reusable-ui/textfield-box";
import {
  removeSpecialCharacters,
  removeSpecialCharAndNumbers,
} from "../../../utils";
import CtaComponent from "../../../components/reusable-ui/cta";

interface Props {
  data?: any;
  modeConfig?: any;
  setModeConfig?: any;
  updateDataInParentState?: any;
  errorMessageMap?: any;
  taxTypeDataMap?: any;
  taxTypeId?: string;
  isChangesMade?: boolean;
  onDiscardCtaClick?: any;
  onSaveCtaClick?: any;
}

const TaxTypeDetailsForm = (props: Props) => {
  const {
    data,
    taxTypeId = "",
    isChangesMade,
    taxTypeDataMap,
    modeConfig,
    setModeConfig,
    updateDataInParentState,
    errorMessageMap,
    onDiscardCtaClick,
    onSaveCtaClick,
  } = props;

  /**
   * This function will render the customTextField input with the help of textFieldConfig
   * @param textFieldConfig
   */
  function renderTextField(textFieldConfig: any): JSX.Element {
    return (
      <CustomTextField
        textBoxLabel={textFieldConfig.fieldLabel}
        placeholder={textFieldConfig.placeHolder}
        regexCheck={textFieldConfig.regexCheck || removeSpecialCharAndNumbers}
        handleChange={textFieldConfig.onSubmit}
        customClass={`min-h-[44px] flex items-center px-16 text-16 font-normal
          ${textFieldConfig.customClass || ""}`}
        parentClass={`${textFieldConfig.boxWidth || ""} ${
          textFieldConfig.parentClass || ""
        }`}
        value={textFieldConfig.value}
        rows={textFieldConfig.rows}
        isMandatory={!!textFieldConfig.isMandatory}
        errorMessage={errorMessageMap[textFieldConfig.key] || ""}
        iconClass={textFieldConfig.iconClass || ""}
        isDisabled={isViewMode(modeConfig?.type)}
      ></CustomTextField>
    );
  }

  function handleInputChange(value: any, fieldToUpdate: string) {
    updateDataInParentState(fieldToUpdate, value);
  }

  return (
    <section
      className={`${
        isAddNewMode(modeConfig.type) ? "w-full" : "w-[50%] p-[24px] pt-0"
      }`}
    >
      {!isAddNewMode(modeConfig.type) && (
        <div className="flex items-center justify-between">
          <div className="text-[20px] font-normal py-[24px] capitalize">
            {taxTypeDataMap[taxTypeId]?.name}
          </div>
          {isViewMode(modeConfig?.type) && (
            <div
              className="flex cursor-pointer"
              onClick={() =>
                setModeConfig({
                  ...modeConfig,
                  type: COMPONENT_MODES.editMode,
                })
              }
            >
              <div className="rista-sprite ic-pencil-blue"></div>
              <p className="text-14 text-blue font-semibold ml-4">Edit</p>
            </div>
          )}
        </div>
      )}
      <div className="bg-white p-[24px]">
        {renderTextField({
          placeHolder: "Enter Tax Name",
          fieldLabel: "Tax Type Name",
          value: get(data, "name") || "",
          boxWidth: "w-full",
          isMandatory: true,
          key: "name",
          regexCheck: (val: any) => val,
          parentKey: "",
          onSubmit: (value: any) => handleInputChange(value, "name"),
          parentClass: "mb-[6px]",
        })}

        {renderTextField({
          placeHolder: "Enter Description",
          fieldLabel: "Description",
          value: get(data, "description") || "",
          boxWidth: "w-full",
          isMandatory: false,
          key: "description",
          regexCheck: (val: any) => val,
          parentKey: "",
          onSubmit: (value: any) => handleInputChange(value, "description"),
          parentClass: "mb-[6px]",
        })}

        {renderTextField({
          placeHolder: "Enter Tax Reporting Name",
          fieldLabel: "Reporting Name",
          value: get(data, "reportingName") || "",
          boxWidth: "w-full",
          isMandatory: false,
          key: "reportingName",
          regexCheck: removeSpecialCharacters,
          parentKey: "",
          onSubmit: (value: any) => handleInputChange(value, "reportingName"),
          parentClass: "mb-[6px]",
        })}
      </div>
      {modeConfig.type === COMPONENT_MODES.editMode && (
        <div className="fixed bottom-[0px] z-[111] bg-white h-[70px] px-24 flex justify-center items-center overflow-hidden right-0 w-[calc(50%-48px)] sm:w-full border-t-[1px] border-[#f5f5f5]">
          <CtaComponent
            ctaText={"Discard"}
            ctaType={CTA_TYPE.secondary_cta}
            ctaSize={CTA_SIZE.medium}
            onCtaClick={onDiscardCtaClick}
            customClass={"w-[calc(50%-10px)] mr-10"}
          ></CtaComponent>
          <CtaComponent
            ctaText={"Save Changes"}
            ctaType={CTA_TYPE.active_cta}
            ctaSize={CTA_SIZE.medium}
            onCtaClick={onSaveCtaClick}
            customClass={"w-[calc(50%-10px)] ml-10"}
            isDisabled={!isChangesMade}
          ></CtaComponent>
        </div>
      )}
    </section>
  );
};

export default TaxTypeDetailsForm;
